import View from './View';

export { default as View, getRemoveDeviceStyles } from './View';

export default View;
